import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { mapParagraphAnimatedNumberElement } from './AnimatedNumberElement';
import {mapParagraphAnimatedNumberRange} from "./AnimatedNumberRange";

export function mapParagraphAnimatedNumbers(
  input: AnimatedNumbersFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'AnimatedNumbers'> {
  return {
    key: 'AnimatedNumbers',
    input: {
      title: input.title || '',
      Link: input.animLink?.url
        ? buildLink({ href: input.animLink.url })
        : undefined,
      linkText: input.animLink?.text || 'Mehr erfahren',
      linkType: input.linkType as boolean,
      items:
        input.items
          ?.filter(cleanList)
          .map((number) => {
            if (number.__typename === 'ParagraphAnimatedNumberElement') {
              return mapParagraphAnimatedNumberElement(number);
            } else {
              return mapParagraphAnimatedNumberRange(number);
            }
          })
          .map((v) => v.input) || [],
    },
  };
}
